(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fc-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.fc-article').forEach(function (root) {
      /* ── Table of contents — built from H2/H3 in the article content ── */
      var content = root.querySelector('[data-fc-article-content]');
      var tocWrap = root.querySelector('[data-fc-article-toc]');

      if (content && tocWrap) {
        var headings = content.querySelectorAll('h2, h3');
        var group = null;
        var links = null;
        var counter = 0;

        function newGroup() {
          group = document.createElement('div');
          group.className = 'fc-article__toc-group';
          links = document.createElement('div');
          links.className = 'fc-article__toc-links';
          tocWrap.appendChild(group);
        }

        headings.forEach(function (h) {
          if (!h.id) {
            counter += 1;
            h.id = 'fc-article-heading-' + counter;
          }

          if (h.tagName === 'H2') {
            newGroup();
            var head = document.createElement('div');
            head.className = 'fc-article__toc-head';
            var headerLink = document.createElement('a');
            headerLink.className = 'fc-article__toc-header';
            headerLink.href = '#' + h.id;
            headerLink.textContent = h.textContent;
            head.appendChild(headerLink);
            group.appendChild(head);
          } else {
            if (!group) newGroup();
            var link = document.createElement('a');
            link.className = 'fc-article__toc-link';
            link.href = '#' + h.id;
            link.textContent = h.textContent;
            if (!links.parentNode) group.appendChild(links);
            links.appendChild(link);
          }
        });

        if (tocWrap.children.length) {
          tocWrap.hidden = false;

          tocWrap.addEventListener('click', function (event) {
            var anchor = event.target.closest('a[href^="#"]');
            if (!anchor) return;
            var target = document.getElementById(decodeURIComponent(anchor.getAttribute('href').slice(1)));
            if (!target) return;
            event.preventDefault();
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
            if (history.replaceState) {
              history.replaceState(null, '', '#' + target.id);
            }
          });
        }
      }

      /* ── Sticky add to cart — visible only after the sidebar product
            card (.fc-article__product-wrap) has been scrolled past ── */
      var stickyBar = root.querySelector('[data-fc-article-sticky-atc]');
      var productWrap = root.querySelector('.fc-article__product-wrap');

      if (stickyBar && productWrap && 'IntersectionObserver' in window) {
        var passedWrap = false;
        var cartDrawer = document.querySelector('ts-cart');
        var drawerOpen = cartDrawer ? cartDrawer.classList.contains('open') : false;

        var updateStickyBar = function () {
          stickyBar.classList.toggle('is-visible', passedWrap && !drawerOpen);
        };

        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            passedWrap = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            updateStickyBar();
          });
        }).observe(productWrap);

        if (cartDrawer && 'MutationObserver' in window) {
          new MutationObserver(function () {
            drawerOpen = cartDrawer.classList.contains('open');
            updateStickyBar();
          }).observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
        }
      }

      /* ── Add to cart — same ts-cart drawer flow as FC Complete Set ── */
      var buttons = root.querySelectorAll('[data-fc-article-add]');
      if (!buttons.length) return;

      function cartUrl() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js';
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = parseInt(btn.getAttribute('data-variant-id'), 10);
          if (!id || btn.classList.contains('is-loading')) return;

          btn.classList.add('is-loading');

          fetch(cartUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: id, quantity: 1 }],
              sections: ['ts-cart-drawer'],
              sections_url: window.location.pathname
            })
          })
            .then(function (response) {
              if (!response.ok) {
                return response.json().then(function (err) {
                  throw new Error(err.description || 'Kon niet toevoegen aan winkelwagen');
                });
              }
              return response.json();
            })
            .then(function (data) {
              var cartElement = document.querySelector('ts-cart');
              if (data.sections && cartElement && typeof cartElement.renderContent === 'function') {
                cartElement.renderContent(data.sections);
                cartElement.open();
              } else {
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              }
            })
            .catch(function (error) {
              console.error('FC Article — add to cart failed:', error);
            })
            .finally(function () {
              btn.classList.remove('is-loading');
            });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-homepage-product-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fcAtcBound) return;
    window.__fcAtcBound = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function setLoading(btn, loading) {
      btn.classList.toggle('is-loading', loading);
      if (loading) {
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('aria-busy');
      }

      var label = btn.querySelector('.fc-atc__button-label');
      if (!label) return;

      if (loading) {
        var loadingText = btn.getAttribute('data-loading-text');
        if (loadingText) {
          if (!btn.dataset.origLabel) btn.dataset.origLabel = label.textContent;
          label.textContent = loadingText;
        }
      } else if (btn.dataset.origLabel) {
        label.textContent = btn.dataset.origLabel;
      }
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fc-atc]');
      if (!btn) return;
      e.preventDefault();

      if (btn.classList.contains('is-loading') || btn.hasAttribute('disabled')) return;

      var id = btn.getAttribute('data-variant-id');
      if (!id) return;

      var cart = document.querySelector('ts-cart');
      var errorEl = btn.parentElement.querySelector('.fc-atc__error');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      setLoading(btn, true);

      var payload = {
        items: [{ id: parseInt(id, 10), quantity: 1 }],
        sections: cart ? ['ts-cart-drawer'] : [],
        sections_url: window.location.pathname
      };

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.data.items) {
            throw new Error((result.data && result.data.description) || 'Add to cart failed');
          }

          if (cart && typeof cart.renderContent === 'function') {
            cart.renderContent(result.data.sections);
            if (typeof cart.open === 'function') cart.open();
          } else {
            window.location.href = root + 'cart';
          }
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = btn.getAttribute('data-error-text') || 'Something went wrong. Please try again.';
            errorEl.hidden = false;
          }
          console.error('FC ATC:', err);
        })
        .finally(function () {
          setLoading(btn, false);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-complete-set"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.fc-cset');

    sections.forEach(function (root) {
      var buttons = root.querySelectorAll('[data-fc-cset-add]');
      if (!buttons.length) return;

      function cartUrl() {
        return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js';
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = parseInt(btn.getAttribute('data-variant-id'), 10);
          if (!id || btn.classList.contains('is-loading')) return;

          btn.classList.add('is-loading');

          fetch(cartUrl(), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: id, quantity: 1 }],
              sections: ['ts-cart-drawer'],
              sections_url: window.location.pathname
            })
          })
            .then(function (response) {
              if (!response.ok) {
                return response.json().then(function (err) {
                  throw new Error(err.description || 'Kon niet toevoegen aan winkelwagen');
                });
              }
              return response.json();
            })
            .then(function (data) {
              var cartElement = document.querySelector('ts-cart');
              if (data.sections && cartElement && typeof cartElement.renderContent === 'function') {
                cartElement.renderContent(data.sections);
                cartElement.open();
              } else {
                // Fallback: hard navigate to the cart if the drawer isn't present
                document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              }
            })
            .catch(function (error) {
              console.error('FC Complete Set — add to cart failed:', error);
            })
            .finally(function () {
              btn.classList.remove('is-loading');
            });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-different"] && !Shopify.designMode) return;
  try {
    
    (function () {
      var carousels = document.querySelectorAll('[data-fc-pdpd-carousel]');

      carousels.forEach(function (root) {
        var track = root.querySelector('[data-fc-pdpd-track]');
        if (!track) return;
        var prev = root.querySelector('[data-fc-pdpd-prev]');
        var next = root.querySelector('[data-fc-pdpd-next]');

        function step() {
          var slide = track.querySelector('.fc-pdpd__slide');
          if (!slide) return track.clientWidth;
          var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16', 10) || 16;
          return slide.getBoundingClientRect().width + gap;
        }

        function update() {
          if (!prev || !next) return;
          var maxScroll = track.scrollWidth - track.clientWidth - 1;
          prev.disabled = track.scrollLeft <= 0;
          next.disabled = track.scrollLeft >= maxScroll;
        }

        if (prev && next) {
          prev.addEventListener('click', function () {
            track.scrollBy({ left: -step(), behavior: 'smooth' });
          });

          next.addEventListener('click', function () {
            track.scrollBy({ left: step(), behavior: 'smooth' });
          });
        }

        /* ── Drag-to-scroll for mouse users (touch keeps native scrolling) ── */
        var isDown = false, startX = 0, startScroll = 0, moved = false;

        track.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'touch') return;
          isDown = true;
          moved = false;
          startX = e.clientX;
          startScroll = track.scrollLeft;
          track.classList.add('is-dragging');
          track.setPointerCapture(e.pointerId);
        });

        track.addEventListener('pointermove', function (e) {
          if (!isDown) return;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 3) moved = true;
          track.scrollLeft = startScroll - dx;
        });

        function endDrag(e) {
          if (!isDown) return;
          isDown = false;
          track.classList.remove('is-dragging');
          if (e && e.pointerId != null && track.hasPointerCapture(e.pointerId)) {
            track.releasePointerCapture(e.pointerId);
          }
        }

        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);

        /* Swallow the click that fires right after a drag so cards don't activate */
        track.addEventListener('click', function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lists = document.querySelectorAll('[data-fc-faq]');

    lists.forEach(function (root) {
      var closeOthers = root.getAttribute('data-close-others') === 'true';
      var buttons = root.querySelectorAll('[data-fc-faq-q]');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.fc-faq__item');
          if (!item) return;
          var willOpen = !item.classList.contains('is-open');

          if (closeOthers && willOpen) {
            root.querySelectorAll('.fc-faq__item.is-open').forEach(function (open) {
              open.classList.remove('is-open');
              var q = open.querySelector('[data-fc-faq-q]');
              if (q) q.setAttribute('aria-expanded', 'false');
            });
          }

          item.classList.toggle('is-open', willOpen);
          btn.setAttribute('aria-expanded', String(willOpen));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-icon-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-fc-mrq]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      var viewport = root.querySelector('[data-fc-mrq-viewport]');
      var track = root.querySelector('[data-fc-mrq-track]');
      var group = root.querySelector('[data-fc-mrq-group]');
      if (!viewport || !track || !group) return;

      var speed = parseFloat(root.getAttribute('data-fc-mrq-speed')) || 50;
      var enabled = root.getAttribute('data-fc-mrq-enabled') !== 'false';
      var clone = null;

      function reset() {
        if (clone) { clone.remove(); clone = null; }
        track.classList.remove('is-marquee');
        viewport.classList.remove('is-scroll');
        track.style.removeProperty('--fc-mrq-shift');
        track.style.removeProperty('--fc-mrq-duration');
      }

      function apply() {
        reset();
        if (!enabled) return;

        // "When the blocks overlap the screen, the marquee is activated."
        var overflows = group.scrollWidth > viewport.clientWidth + 1;
        if (!overflows) return;

        if (reduce) {
          viewport.classList.add('is-scroll');
          return;
        }

        track.classList.add('is-marquee');
        // offsetWidth now includes the trailing gap (padding-right)
        var shift = group.offsetWidth;
        clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-fc-mrq-group');
        track.appendChild(clone);

        track.style.setProperty('--fc-mrq-shift', shift + 'px');
        track.style.setProperty('--fc-mrq-duration', (shift / speed).toFixed(2) + 's');
      }

      var timer;
      function onResize() {
        clearTimeout(timer);
        timer = setTimeout(apply, 150);
      }

      apply();
      window.addEventListener('resize', onResize);
      // Re-measure once web fonts / images have loaded (widths change)
      window.addEventListener('load', apply);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(apply);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-pdp-trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* ── Live TrustBoxes: per-viewport height + re-render ──
       Same approach as the Micro Combo next to the product title
       (ts-main-product.liquid): the iframe is cross-origin, so swap the
       data-style-* config and re-render via Trustpilot.loadFromElement. */
    var mq = window.matchMedia('(max-width: 749px)');
    var liveWidgets = document.querySelectorAll('.fc-tp .trustpilot-widget[data-tp-desktop-height]');

    function applyLive(rerender) {
      liveWidgets.forEach(function (widget) {
        var d = widget.dataset;
        widget.setAttribute('data-style-height', mq.matches ? d.tpMobileHeight : d.tpDesktopHeight);
        if (rerender && window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
          window.Trustpilot.loadFromElement(widget, true);
        }
      });
    }

    if (liveWidgets.length) {
      applyLive(!!window.Trustpilot);
      if (mq.addEventListener) {
        mq.addEventListener('change', function () { applyLive(true); });
      } else if (mq.addListener) {
        mq.addListener(function () { applyLive(true); });
      }
    }

    var carousels = document.querySelectorAll('[data-fc-tp-carousel]');

    carousels.forEach(function (root) {
      var track = root.querySelector('[data-fc-tp-track]');
      if (!track) return;

      var section = root.closest('.fc-tp');
      var prev = section ? section.querySelector('[data-fc-tp-prev]') : null;
      var next = section ? section.querySelector('[data-fc-tp-next]') : null;

      function step() {
        var slide = track.querySelector('.fc-tp__slide');
        if (!slide) return track.clientWidth;
        var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16', 10) || 16;
        return slide.getBoundingClientRect().width + gap;
      }

      function update() {
        if (!prev || !next) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      if (prev && next) {
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        next.addEventListener('click', function () {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      /* ── Drag-to-scroll for mouse users (touch keeps native scrolling) ── */
      var isDown = false, startX = 0, startScroll = 0, moved = false;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture(e.pointerId);
      });

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startScroll - dx;
      });

      function endDrag(e) {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        if (e && e.pointerId != null && track.hasPointerCapture(e.pointerId)) {
          track.releasePointerCapture(e.pointerId);
        }
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
